import { useQuery } from 'wasp/client/operations';
import { getUserMembership } from 'wasp/client/operations';
import { useAuth } from 'wasp/client/auth';
import type { LocationMembership } from 'wasp/entities';
import { isAdministrator } from '../../client/lib/platformRole';
import {
  NOTICE_PRIORITY_OPTIONS,
  canSetVeryHighPriority,
  type NoticePriority,
} from './noticeConstants';

type NoticePriorityFieldProps = {
  value: NoticePriority;
  onChange: (value: NoticePriority) => void;
  locationId?: string;
  className?: string;
};

export function NoticePriorityField({
  value,
  onChange,
  locationId,
  className,
}: NoticePriorityFieldProps) {
  const { data: user } = useAuth();
  const { data: membershipData } = useQuery(
    getUserMembership,
    { locationId: locationId! },
    { enabled: !!locationId }
  );
  const membership = membershipData as LocationMembership | null | undefined;

  const showVeryHigh = canSetVeryHighPriority(
    membership?.role,
    user ? isAdministrator(user) : false
  );

  const options = NOTICE_PRIORITY_OPTIONS.filter(
    (option) =>
      option.value !== 'very_high' || showVeryHigh || value === 'very_high'
  );

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as NoticePriority)}
      className={className}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export function useCanSetVeryHighPriority(locationId?: string): boolean {
  const { data: user } = useAuth();
  const { data: membershipData } = useQuery(
    getUserMembership,
    { locationId: locationId! },
    { enabled: !!locationId }
  );
  const membership = membershipData as LocationMembership | null | undefined;

  return canSetVeryHighPriority(membership?.role, user ? isAdministrator(user) : false);
}
